export const PERMISSIONS = Object.freeze({
  ALL: "*",
  OWN_PROFILE_UPDATE: "own-profile:update",
  OWN_ACTIVITY_VIEW: "own-activity:view",
  CHAT_USE: "chat:use",
  WORKERS_VIEW: "workers:view",
  WORKERS_MANAGE: "workers:manage",
  PATIENTS_VIEW: "patients:view",
  PATIENTS_CREATE: "patients:create",
  PATIENTS_UPDATE: "patients:update",
  PATIENTS_APPROVE: "patients:approve",
  PATIENT_FILES_VIEW: "patient-files:view",
  PATIENT_FILES_UPLOAD: "patient-files:upload",
  PATIENT_FILES_MANAGE: "patient-files:manage",
  CLINICAL_PROFILE_UPDATE: "clinical-profile:update",
  APPOINTMENTS_VIEW: "appointments:view",
  APPOINTMENTS_CREATE: "appointments:create",
  APPOINTMENTS_HANDLE: "appointments:handle",
  APPOINTMENTS_REOPEN: "appointments:reopen",
  ASSESSMENTS_CREATE: "assessments:create",
  ASSESSMENTS_UPDATE_OWN: "assessments:update-own",
  REQUEST_FORMS_VIEW: "request-forms:view",
  REQUEST_FORMS_MANAGE_ASSIGNED: "request-forms:manage-assigned",
  REQUEST_FORMS_MARK_PAID: "request-forms:mark-paid",
  AUDIT_LOGS_VIEW: "audit-logs:view",
  UNIT_ADMIN_ACCESS: "unit-admin:access",
});

export const PERMISSION_LABELS = Object.freeze({
  [PERMISSIONS.ALL]: "Full access to every current and future system capability",
  [PERMISSIONS.OWN_PROFILE_UPDATE]: "Update their own staff profile",
  [PERMISSIONS.OWN_ACTIVITY_VIEW]: "View their own work activity history",
  [PERMISSIONS.CHAT_USE]: "Exchange private text messages with other staff",
  [PERMISSIONS.WORKERS_VIEW]: "View staff profiles and select staff for handoffs",
  [PERMISSIONS.WORKERS_MANAGE]: "Activate staff accounts and manage worker roles",
  [PERMISSIONS.PATIENTS_VIEW]: "View patient records",
  [PERMISSIONS.PATIENTS_CREATE]: "Register new patients",
  [PERMISSIONS.PATIENTS_UPDATE]: "Update patient biodata and next-of-kin details",
  [PERMISSIONS.PATIENTS_APPROVE]: "Approve patient records",
  [PERMISSIONS.PATIENT_FILES_VIEW]: "View scanned historical patient files",
  [PERMISSIONS.PATIENT_FILES_UPLOAD]: "Upload scanned historical patient files",
  [PERMISSIONS.PATIENT_FILES_MANAGE]: "Edit, archive and restore scanned patient files",
  [PERMISSIONS.CLINICAL_PROFILE_UPDATE]: "Update allergies, conditions and other clinical profile information",
  [PERMISSIONS.APPOINTMENTS_VIEW]: "View attendances and appointment history",
  [PERMISSIONS.APPOINTMENTS_CREATE]: "Start a patient attendance",
  [PERMISSIONS.APPOINTMENTS_HANDLE]: "Handle, claim, forward and close assigned attendances",
  [PERMISSIONS.APPOINTMENTS_REOPEN]: "Reopen a closed attendance",
  [PERMISSIONS.ASSESSMENTS_CREATE]: "Create doctor assessments",
  [PERMISSIONS.ASSESSMENTS_UPDATE_OWN]: "Update or remove assessments they authored",
  [PERMISSIONS.REQUEST_FORMS_VIEW]: "View request forms they are permitted to access",
  [PERMISSIONS.REQUEST_FORMS_MANAGE_ASSIGNED]: "Create, edit, send, return and archive assigned request forms",
  [PERMISSIONS.REQUEST_FORMS_MARK_PAID]: "Confirm payment on assigned request forms",
  [PERMISSIONS.AUDIT_LOGS_VIEW]: "View security and administrative audit logs",
  [PERMISSIONS.UNIT_ADMIN_ACCESS]: "Administer records and workers within their assigned unit",
});
